import barba from '@barba/core'
import Plyr from 'plyr'
import { setLocalStorageItem } from '../utilities'

const activeClass = 'is-active'
const errorClass = 'is-error'

export const plyrOptions = {
  debug: false,
  loadSprite: false,
  seekTime: 30,
  muted: true,
  fullscreen: {
    enabled: true,
    fallback: false,
    iosNative: true,
    container: null,
  },
  settings: ['captions', 'quality'],
  controls: [
    'play-large',
    'play',
    'progress',
    'current-time',
    'duration',
    'mute',
    'volume',
    'captions',
    'settings',
    'pip',
    'airplay',
    'fullscreen',
  ],
}

export default class {
  constructor(el, options) {
    options = Object.assign(
      {
        padding: '56.25',
      },
      options
    )

    const videoEl = el.querySelector('.js-video')

    videoEl.style.paddingBottom = ''

    const savedTimeDuration = 604800000 // 1 week
    const savedTimeKey = `play-video-${options.id}`
    let saveInterval = null

    const player = new Plyr(videoEl, plyrOptions)

    player.config.i18n.captions = 'Subtitles'

    barba.hooks.before(function () {
      if (player.elements && player.elements.container) {
        player.destroy()
      }
    })

    function restoreVideoToIframe() {
      player.destroy()

      window.setTimeout(() => {
        el.classList.add(errorClass)

        const restoredVideoEl = el.querySelector('.js-video')
        restoredVideoEl.style.paddingBottom = `${options.padding}%`
      }, 1000)
    }

    function onError(error, player) {
      console.error(error)

      if (error.detail.method === 'setPlaybackRate') {
        return
      }

      console.error('Video player error', error.detail, player)

      /*
      let url = barba.url.getHref()

      if (url.includes('video_fallback')) {
        console.error('Video has error with fallback')

        return
      }

      if ((player.isYouTube || player.isVimeo)) {
        if (window.confirm('Something went wrong loading the video. We will try to reload the page in safe-mode if that’s ok?')) {
          if (url.endsWith('/')) {
            url = url.slice(0, -1)
          }

          url += url.includes('?') ? '&' : '?'
          url += 'video_fallback=1'

          barba.go(url)
        }
      }
      */
    }

    function saveTime() {
      const now = new Date()
      const saveItem = {
        exp: now.getTime() + savedTimeDuration,
        value: Math.floor(player.currentTime),
      }

      setLocalStorageItem(savedTimeKey, JSON.stringify(saveItem))
    }

    function getSavedTime() {
      const savedTime = window.localStorage.getItem(savedTimeKey)

      if (!savedTime) {
        return 0
      }

      const savedData = JSON.parse(savedTime)
      const now = new Date()

      if (now.getTime() > savedData.exp) {
        window.localStorage.removeItem(savedTimeKey)
        return 0
      }

      return parseInt(savedData.value)
    }

    player.on('error', function (error) {
      onError(error, player)
    })

    player.on('seeked', saveTime)

    player.on('play', function () {
      saveInterval = setInterval(saveTime, 3000)
    })

    player.on('pause', function () {
      clearInterval(saveInterval)
    })

    player.on('ended', function () {
      window.localStorage.removeItem(savedTimeKey)

      if (player.isYouTube) {
        player.stop()
      }
    })

    player.on('ready', function () {
      const isReadyInterval = setInterval(function () {
        if (player.duration > 0) {
          clearInterval(isReadyInterval)

          const savedTime = getSavedTime()

          if (savedTime <= player.duration && !player.playing) {
            player.currentTime = savedTime
          }

          setTimeout(function () {
            el.classList.add(activeClass)
            player.muted = false
          }, 1000)
        }
      }, 300)

      window.setTimeout(() => {
        if (player.isVimeo) {
          player.embed.getBuffered().catch((error) => {
            if (error.name === 'PrivacyError') {
              restoreVideoToIframe()
            }
          })
        }
      }, 3000)
    })
  }
}
